<template>
  	<div class="ioRecord">
		
		<!-- <div class="left content-left">
			<AreaTree v-on:handleTreeClick='handleTreeClick'></AreaTree>
		</div> -->
		<div class="">
			<!--左侧上方搜索框-->
			<div class="searchbox">
				<form action="#" method="get" class="form-inline form-float">
					<div class="form-group">
						<label for="bdate">开始时间:</label>
						<el-date-picker clearable
							value-format="yyyy-MM-dd HH:mm:ss"
							v-model="search.beginDate"
							type="date"
							>
						</el-date-picker>
					</div>
					<div class="form-group">
						<label for="bdate">结束时间:</label>
						<el-date-picker clearable
							value-format="yyyy-MM-dd HH::mm:ss"
							v-model="search.endDate"
							type="date"
							r>
						</el-date-picker> 
					</div>
				
					<div class="form-group others">
						<span class='search_btn'><button @click="searchList" type="button" class="btn btn-primary" id="search_btn">查询</button></span>
						<!--<button @click="clearSearch" type="button" class="btn btn-default">清空</button>-->
					
						<!-- <span class="refresh_btn"><Refresh @tableList="this.tableList"></Refresh></span> -->
						<!-- <span class='switchGroup'>
								<el-select v-model="switchValue" placeholder="">
									<el-option value='list' label='列表'>
										<span class='switch'><img src="@/assets/images/liebiao.png" width='16px'/><span class='switch-info'>列表</span></span>
									</el-option>
									<el-option value='chart' label='图表'>
										<span class='switch'><img src="@/assets/images/tubiao.png" width='16px'/><span class='switch-info'>图表</span></span>
									</el-option>
  								</el-select>
						</span> -->
					</div>

				</form>
			</div>
			<template>
					<div v-show='showChart' id="myChart" style="width:100%;height:500px"></div>
					<div v-show='showList' class='show-list list-right'>
						<el-table
						border
						:data="tableListData"
						height='100%'
						width="100%"
						:header-cell-style='tableHeaderStyle'
						:cell-style='styleObj'
						>
						<!-- <el-table-column  show-overflow-tooltip
						label="车场名称"
						prop="">

						</el-table-column> -->
						<el-table-column  show-overflow-tooltip
						label="统计时间"
						prop="chargeDate"
						>
						</el-table-column>
						<el-table-column  show-overflow-tooltip
						label="应收金额"
						prop="receivable"
						>
						</el-table-column>
						<el-table-column  show-overflow-tooltip
						label="实收金额"
						prop="real_money"
						>
						</el-table-column>
						<el-table-column  show-overflow-tooltip
						label="差异金额"
						prop="difference">
						</el-table-column>
						<el-table-column  show-overflow-tooltip
						label="临停缴费"
						prop="TEMPORARY"
						>
						</el-table-column>
						<el-table-column  show-overflow-tooltip
						label="固定车收费"
						prop="fixed"
						>
						</el-table-column>
						<el-table-column  show-overflow-tooltip
						label="线上缴费"
						prop="onlineMoney"
						>
						</el-table-column>
						<el-table-column  show-overflow-tooltip
						label="现金缴费"
						prop="cashMoney"
						>
						</el-table-column>
						<el-table-column  show-overflow-tooltip
						label="消费打折"
						prop="discount_money"
						>
						</el-table-column>
						</el-table>
						<!-- <Page :pageSize="search.pageSize"></Page> -->
						<Page v-on:pagination='receivePaginationData'></Page>
					</div>
			</template>
		
				
				
			</div>
		</div>
		
		

</template>

<script>
	import { mapState, mapMutations } from 'vuex';
	import {getOnsiteGroupDayReportList} from '@/api/url';
	import AreaTree from '../../commons/parking/commons/areaTree.vue';
	import Page from '../../commons/parking/commons/page.vue';
	// import Refresh from '../commons/refresh.vue';
	export default{
		data(){
			return{
				treeData:{
					parkingId:'',
				},
				styleObj:{
					'text-align':'center',
				},
				tableHeaderStyle:{
					'text-align':'center',
					'background':'#F9F9FB'
				},
				switchValue:'list',
				showList:true,
				showChart:false,
				search:{
					pageSize:10,
					pageNumber:1,
					beginDate:'',
					endDate:''
				},
				tableListData:[],
                myChart : {
				// 	 title : {
				// 		text: '每天收费统计',
				// 		subtext: '近一个月',
				// 		x: 'center',
        		// align: 'right'

				// 	},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'cross',
							crossStyle: {
								color: '#999'
							}
						}
					},
					// legend: {
					// 	data:['支付宝','微信','现金','建行无感','余额支付','总和'],
					// 	x: 'left'
					// },
				
					xAxis: [{
						name: "时间",
						splitLine: { show: true },
						axisLabel: {
							interval: 0,
							rotate: 40,
							color: "#333333"
						},
						axisLine: {
							lineStyle: { color: "#4488BB", width: 2 }
						},
						splitLine: { show: true },
						type: 'category',
						data: [] //时间
					}],
					yAxis: [
						{
						},
						{
						}
					],
					series: [
						{
							name:'总和',
							type:'line',
							data:[],
							itemStyle: {
							normal: {
								label: {
									show: true, //开启显示
									position: 'top', //在上方显示
									textStyle: { //数值样式
										color: '#5dacff',
										fontSize: 12
									}
								}
							}
						},
						smooth: true,
						}
					]
				},
			}
		},
		methods:{
			...mapMutations(['getPage']),
			//点击树的节点展示相应数据
			// handleTreeClick:function(node,data){
			// 		this.switchValue='list';
			// 		this.showList=true;
			// 		this.showChart=false;
			// 		this.search.beginDate='';
			// 		this.search.endDate='';

			// 		if(node.type=='parking'){
			// 		this.treeData.parkingId=node.id;
			// 		this.search.pageNumber=1;
			// 		this.tableList(this.search.pageNumber);
			// 		}else{
			// 		this.treeData.parkingId='';
			// 		this.tableListData=[];
			// 		 this.$message({
			// 			message: '请选择车场！',
			// 			type: 'warning'
			// 			});
			// 		}
					
					
			// },
			receivePaginationData(v1,v2){
				this.search.pageNumber=v1;
				this.search.pageSize=v2;
				this.tableList(this.search.pageNumber);
			},
			tableList:function(curPage){
				var _this=this;
				this.$get(getOnsiteGroupDayReportList(),{
					page:curPage,
					limit:this.search.pageSize,
					parkingId:this.treeData.parkingId,
					beginTime:this.search.beginDate,
					endTime:this.search.endDate
				}).then((data) => {
    				if(data.status!=200) return _this.$layer.msg(data.message);
					//翻页
					var pageObj={
						curIndex:data.data.offset,
						rowsCount:data.data.total
					};
					_this.getPage(pageObj);
					_this.tableListData=data.data.rows;
					
  				});

			},
			echarts:function(){
                this.myChart.series[0].data=[];
                this.myChart.xAxis[0].data=[];
				var _this=this;
				this.$get(chargeOfDay(),{
					parkingId:this.treeData.parkingId,
					beginTime:this.search.beginDate,
					endTime:this.search.endDate,
			    
			    }).then((data) => {
                    // if(data.status!=200) return;
					for(var i in data){
						
						this.myChart.series[0].data.push(data[i].totalMoney);
						this.myChart.xAxis[0].data.push(data[i].datelist);
					}
					
					// let myChart = this.$echarts.init(document.getElementById('myChart'));
					// myChart.setOption(this.myChart);
				  });
			},
			searchList:function(){
				// if(this.treeData.parkingId){
				// 	this.search.pageNumber=1;
				// 	this.tableList(this.search.pageNumber);
				// }
				// else{
				// 	 this.$message({
				// 		message: '请选择车场！',
				// 		type: 'warning'
				// 		});
				// 	}
				var flTime=this.timeCompare(this.search.beginDate,this.search.endDate);
				if(flTime){
					return this.$layer.msg('开始时间请勿大于结束时间', { time: 1});
				}else if(!Boolean(this.search.beginDate)&&Boolean(this.search.endDate)){
					return this.$layer.msg('请选择开始时间', { time: 1});
				}else if(Boolean(this.search.beginDate)&&!Boolean(this.search.endDate)){
					return this.$layer.msg('请选择结束时间', { time: 1});
				}
					this.search.pageNumber=1;
					this.tableList(this.search.pageNumber);
				this.echarts();
			},
			clearSearch:function(){
				this.search.pageNumber="1";
				this.search.fbMsg="";
			},
			timeCompare:function(bDateVal,eDateVal){

				if(!Boolean(bDateVal)||!Boolean(eDateVal)){
					return false;
				}
				var bdate = new Date(Date.parse(bDateVal.replace(/-/g, "/")));
				bdate = bdate.getTime();
				var edate = new Date(Date.parse(eDateVal.replace(/-/g, "/")));
				edate = edate.getTime();
				if(bdate-edate>0){
					return true;
				}else{
					return false;
				}
			},
			
		},
		computed:{
			...mapState({
			curIndex: state => state.page.curIndex,
			rowsCount: state => state.page.rowsCount,
			nodeData: state => state.nodeData,
			nod:state=>state.nod
			}),
		},
		components:{
			Page,
			AreaTree,
			
		},
		
		mounted:function(){
			// this.echarts();
			this.tableList(this.search.pageNumber)
		},
		watch:{
			switchValue:function(newVal, oldVal){
				if(newVal==="chart"){
					this.showChart=true;
					this.showList=false;
					// this.$nextTick(function(){let myChart = this.$echarts.init(document.getElementById('myChart'));
					// myChart.setOption(this.myChart);})
				
				}else{
					this.showChart=false;
					this.showList=true;
				}
			},
		}
	}

</script>

<style scoped>
	.table  tr td{
		text-align:center;
	}

	.modal-body .tab-img li{
		width:100px;
		height:100px;
		margin:10px 10px;
	}
	.table thread tr td{
		text-align: center;
	}
	.pagbox{
		position:absolute;
		bottom:20px;
		right:20px;
	}
	.searchbox{
		background: #f9f9fb;
		border-bottom:10px solid #eff2f7;
	}
	.form-inline{
		display:flex;
		display:-webkit-flex;
		flex-wrap:wrap; 
		align-items:center;
		height:90px;
	}
	.search_btn,.download_btn,.refresh_btn{
		display:inline-block;
	}
	.refresh_btn{
		display:-webkit-flex;
		display:flex;
		align-items:center;
	}
	.others{
		display:-webkit-flex;
		display:flex;
		justify-content: center;
	} 
    #myChart{
        overflow-x: auto;
    }
	.form-group .switchGroup{
		margin-left:50px;
		display:flex;
		align-items: center;
		
		
	}
	.switch-info{
		display:inline-block;
		margin-left:5px;
	}
	.show-list{
		height:500px;
	}
</style>
<style>
.ioRecord  .el-select{
	width:100px;
}
.switchGroup  .el-input__inner{
	 border:1px solid #67C23A;
		border-radius:4px;
}
</style>

 